module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "UserViewing"
  }, [_c('div', {
    staticClass: "form-group col-md-5"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.workflowAttribute.name))]), _vm._v(" "), _vm._l((_vm.inputTypes), function(type) {
    return _c('div', [(type['.key'] == _vm.workflowAttribute.type) ? _c('p', [_vm._v(_vm._s(type.name))]) : _vm._e()])
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workflowAttribute.active == true ? 'Active' : 'Inactive'))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.org['curOrg']['role'] == '1' || _vm.org['curOrg']['role'] == 99) ? _c('button', {
    staticClass: "btn  btn-default form-group",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "UserEditing col-md-5"
  }, [_c('form-text', {
    ref: "name",
    attrs: {
      "label": "Name",
      "name": "name",
      "validation": "required"
    },
    model: {
      value: (_vm.workflowAttributeEdit.name),
      callback: function($$v) {
        _vm.$set(_vm.workflowAttributeEdit, "name", $$v)
      },
      expression: "workflowAttributeEdit.name"
    }
  }), _vm._v(" "), _c('form-select', {
    ref: "type",
    attrs: {
      "label": "Type",
      "name": "type",
      "options": _vm.inputTypes,
      "validation": "required"
    },
    model: {
      value: (_vm.workflowAttributeEdit.type),
      callback: function($$v) {
        _vm.$set(_vm.workflowAttributeEdit, "type", $$v)
      },
      expression: "workflowAttributeEdit.type"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-checkbox', {
    attrs: {
      "label": "Active",
      "name": "active"
    },
    model: {
      value: (_vm.workflowAttributeEdit.active),
      callback: function($$v) {
        _vm.$set(_vm.workflowAttributeEdit, "active", $$v)
      },
      expression: "workflowAttributeEdit.active"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_vm._v("Submit")])])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c36f03d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/WorkflowAttributes/WorkflowAttributeDetail.vue
// module id = 663
// module chunks = 1